import { createFileRoute, useParams } from '@tanstack/react-router';
import { fundingDetailSearchSchema } from '@/pages/ai-matching-results/lib/fundingDetailSearchSchema';
import { FundingDetailPageView } from '@/pages/ai-matching-results/ui/FundingDetailPageView';

const NationalGrantsFundingDetailPage = () => {
  const { documentId, recordId } = useParams({
    from: '/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId',
  });
  const search = Route.useSearch();
  return (
    <FundingDetailPageView
      category="national-grants"
      documentId={documentId}
      recordId={recordId}
      search={search}
    />
  );
};

export const Route = createFileRoute(
  '/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId',
)({
  component: NationalGrantsFundingDetailPage,
  validateSearch: (search) => fundingDetailSearchSchema.parse(search),
});
